import React, {Component} from 'react';
import {NavLink} from "react-router-dom";
import {getCartProducts, getServiceCharge, updateCart} from "../common/Common";

class Cart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cartProducts: [],
            error: false,
            success: false,
            errorMessage: null,
            total: 0.00,
            serviceCharge: 0.00
        };
    }

    componentDidMount() {
        getCartProducts().then(data => {
            let total = 0.00;
            data.forEach((product) => {
                total += product.price * product.quantity;
            });
            let serviceCharge = getServiceCharge(total);
            total += serviceCharge;
            this.setState({cartProducts: data, total: total, serviceCharge: serviceCharge});
        }).catch(() => null);
    }

    render() {
        return (
            <div>
                {this.state.cartProducts.length === 0 ?
                    <p>No items in the cart</p>
                    : [
                        <table className="w-100" key="cart-table">
                            <thead>
                            <tr>
                                <th>Product</th>
                                <th>Price</th>
                                <th className="cart-quantity-column">Quantity</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.getCartProductBody()}
                            </tbody>
                        </table>,
                        <hr key="hr"/>,
                        <table className="w-100" key="service-charge-table">
                            <thead>
                            <tr>
                                <th className="checkout-form">Service Charge</th>
                                <th className="checkout-cart">
                                    <h4 className="heading">Rs.{this.state.serviceCharge}</h4>
                                </th>
                            </tr>
                            </thead>
                        </table>,
                        this.props.component === 'Header' ?
                            <NavLink className="nav-link sign-up-link" to="/checkout" key="checkout" target="_top">
                                <button type="submit" className="btn blue-button login-button w-100">
                                    Checkout Rs.{this.state.total}
                                </button>
                            </NavLink>
                            : [
                                <hr key="hr2"/>,
                                <table className="w-100" key="cart-table">
                                    <thead>
                                    <tr>
                                        <th className="checkout-form">Total</th>
                                        <th className="checkout-cart">
                                            <h4 className="heading">Rs.{this.state.total}</h4>
                                        </th>
                                    </tr>
                                    </thead>
                                </table>,
                                <hr key="hr3"/>,
                                <hr key="hr4"/>
                            ]
                    ]
                }
                {(this.state.error || this.state.success) &&
                <div className={"alert" + (this.state.error ? " alert-danger" : " alert-success")}
                     role="alert">
                    {this.state.errorMessage}
                </div>}
            </div>
        );
    };

    getCartProductBody = () => {
        let productBody = [];
        this.state.cartProducts.forEach((product, index) => {
            productBody.push(
                <tr key={index}>
                    <td className="text-capitalize">{product.name}</td>
                    <td>{product.price}</td>
                    <td>
                        <input className="form-control" type="number" placeholder='Quantity*' id="quantity"
                               min="1" max={product.stock} defaultValue={product.quantity} required
                               onBlur={(event) => this.updateCart(event, index, 'update quantity')}/>
                    </td>
                    <td className="cart-remove-product-column">
                        <button className="btn blue-border-button login-button"
                                onClick={(event) => this.updateCart(event, index, 'remove')}>
                            Remove
                        </button>
                    </td>
                </tr>
            );
        });
        return productBody;
    };

    updateCart = (event, index, action) => {
        event.preventDefault();
        let products = this.state.cartProducts;
        let total = 0.00;
        if (action === 'remove') {
            products.splice(index, 1);
        } else {
            products[index].quantity = event.target.value;
        }
        products.forEach((product) => {
            total += product.price * product.quantity;
        });
        let serviceCharge = getServiceCharge(total);
        total += serviceCharge;
        updateCart(products).then(() => {
            this.setState({
                cartProducts: products,
                total: total,
                serviceCharge: serviceCharge,
                error: false,
                success: true,
                errorMessage: action === 'remove' ? 'Successfully Removed Product from Cart' : 'Successfully Updated Quantity'
            });
            if (this.props.component === 'Checkout') {
                this.props.getCart();
            }
        }).catch(() => {
            this.setState({
                error: true,
                errorMessage: action === 'remove' ? 'An error occurred while removing product from cart' : 'An error occurred while updating quantity'
            })
        });
    }
}

export default Cart;